import { useEffect, useRef } from "react";

export const SignalMeter = () => {
  const bar = useRef(null);
  const pct = useRef(null);

  useEffect(() => {
    let raf = 0;
    const update = () => {
      raf = 0;
      const h = document.documentElement;
      const p = Math.min(1, h.scrollTop / Math.max(1, h.scrollHeight - h.clientHeight));
      bar.current.style.transform = `scaleX(${p})`;
      pct.current.textContent = String(Math.round(p * 100)).padStart(3, "0");
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(update); };
    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div className="signal" aria-hidden="true" data-testid="header-signal-meter">
      <span className="signal-label mono">
        SIG <span ref={pct}>000</span>%
      </span>
      <span className="signal-track">
        <span ref={bar} className="signal-fill" />
      </span>
    </div>
  );
};
